import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getExternalLinksConfig} from 'src/openapi/admin/apis/ClientConfigApi';
import {useAppDispatch} from 'src/store/hooks';

export const useExternalLinksConfig = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getExternalLinksConfig(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            platformLink: '',
        },
        getDispatchAction,
    });
};
